import React from 'react';
import PropTypes from 'prop-types';
import { Box } from '@mui/material';
import Recommendation from './style';

const TabNavigation = ({ tabs, selectedTab, onTabClick }) => {
    return (
        <Box sx={Recommendation.TabNavigation.container}>
            {tabs.map((tab, index) => (
                <Box key={index} sx={Recommendation.TabNavigation.tab(index === selectedTab)} onClick={() => onTabClick(index)}>
                    <Box sx={Recommendation.TabNavigation.tabContent}>
                        <Box component="img" src={tab.iconSrc} alt={`${tab.text} icon`} sx={Recommendation.TabNavigation.icon} />
                        <Box sx={Recommendation.TabNavigation.text}>{tab.text}</Box>
                    </Box>
                </Box>
            ))}
        </Box>
    );
};

TabNavigation.propTypes = {
    tabs: PropTypes.arrayOf(
        PropTypes.shape({
            iconSrc: PropTypes.string.isRequired,
            text: PropTypes.string.isRequired,
        })
    ).isRequired,
    selectedTab: PropTypes.number.isRequired,
    onTabClick: PropTypes.func.isRequired,
};

export default TabNavigation;
